// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"8d1d40a9","343":"81745a8c","465":"61a6c281","744":"8f4f700c","908":"294e7167"}[chunkId] + ".chunk.js";
};